import React from 'react';
import SVGChart from '../../charting/SVGChart/SVGChart.jsx';
import Axis from '../../charting/Axis/Axis.jsx';
import SizeGiver from '../../../containers/SizeGiver/SizeGiver.jsx';
import d3 from 'd3';

const tickWidth = 10;
const chartstyles= {
  width   : "100%",
  height  : 25,
  paddingLeft : 4,
  paddingRight: 20,
  paddingTop: Math.ceil(tickWidth/2),
  paddingBottom: 0
};

const chartdata = {
    xTicks: [0,100,200,300,400],
    xTickFormat: function(val,i) { return val+(i==4?"m":""); },
};


/*const ySettings = {
    translate: 'translate(' + props.paddingLeft + ', 0)',
    scale: props.yScale,
    orient: 'left',
    tickFormat: props.yTickFormat,
    ticks: props.yTicks,
    tickWidth: props.transverse?null:(props.width - props.paddingLeft - props.paddingRight),
    translateTicks: props.transverse?null:[props.width - props.paddingLeft - props.paddingRight,0],
    zeroClass: 'zerotick',
    hideAxis: props.hideYAxis?true:false
  };*/



const ShipAxis = (props) => {
    const xSettings = {
        scale: d3.scale.linear().domain([d3.min(props.xTicks), d3.max(props.xTicks)])
            .range([props.paddingLeft, props.width - props.paddingRight]),
        orient: 'bottom',
        tickFormat: props.xTickFormat,
        ticks: props.xTicks,
        tickWidth: tickWidth,
        translateTicks: [0,-1*tickWidth/2]
    };
    return <g style={{transform:"translate(0,"+props.paddingTop+"px)"}}><Axis {...xSettings}/></g>
}

export default (props) => {
    
    return <div className="capacity_chart">
        <div className="caplegend"><div className="teu"></div> = 100 standard containers (100 TEU)</div>
        <div style={{paddingLeft:chartstyles.paddingLeft+"px",paddingRight:chartstyles.paddingRight+"px"}}>
            <div className="capacity"><strong>Fully Cellular (1970-)</strong>: 1,000-2,500 TEU</div>
            <img style={{width:"53.75%"}}src="images/shipcaps_cellular.svg"/>
            <div className="capacity"><strong>Panamax (1980-)</strong>: 3,000-3,400 TEU</div>
            <img style={{width:"62.5%"}}src="images/shipcaps_panamax.svg"/>
            <div className="capacity"><strong>Post Panamax I (1988-)</strong>: 4,000-5,000 TEU</div>
            <img style={{width:"71.25%"}} src="images/shipcaps_post-panamax.svg"/>
            <div className="capacity"><strong>Post Panamax II (2000-)</strong>: 6,000-8,000 TEU</div>
            <img style={{width:"75%"}} src="images/shipcaps_post-panamax-plus.svg"/>
            <div className="capacity"><strong>Triple-E (2013-)</strong>: 18,000 TEU</div>
            <img style={{width:"100%"}} src="images/shipcaps_triple-e.svg"/>
        </div>
        <div className="shipcap-axis">
            <SizeGiver>
                <SVGChart {...chartstyles} {...chartdata}>
                    <ShipAxis/>    
                </SVGChart>
            </SizeGiver>
        </div>
    </div>

}


// WEBPACK FOOTER //
// ./src/js/components/special/ShipChart/ShipChart.jsx